import { LocaleItemProps } from "apis";
import { lazy } from "react";

export const PageAdminLocale = lazy(() => import("./List"));
export const PageAdminLocaleCreate = lazy(() => import("./Add"));
export const PageAdminLocaleUpdate = lazy(() => import("./Edit"));
export const PageAdminLocaleTranslate = lazy(() => import("./Translate"));

export interface FormLocaleValuesProps extends Omit<LocaleItemProps, "translateEditor"> {
    translateEditor?: string;
}

export interface FormTranslateLocaleValuesProps extends Omit<LocaleItemProps, "translateEditor" | "translateI18n"> {
    translateEditor?: string;
    translateI18n?: { [key: string]: string }
}